import React, { FC } from "react";

import Typography from "@mui/material/Typography";

import Card from "components/Card";
import CustomButton from "components/CustomButton";

import { PRODUCTION_STATUSES } from "enums/productionStatuses";

import { EXTERNAL_ROUTES } from "config/routes";

import styles from "./styles";

type DecentralandRedeemedInfoProps = {
  productionStatus: PRODUCTION_STATUSES | null;
  dclContractAddress: string | null;
  dclTokenId: string | null;
};

const DecentralandRedeemedInfo: FC<DecentralandRedeemedInfoProps> = ({
  productionStatus,
  dclContractAddress,
  dclTokenId,
}) => {
  return (
    <Card bg="plain" sx={styles.card}>
      {(!productionStatus ||
        productionStatus !== PRODUCTION_STATUSES.DELIVERY) && (
        <Typography mb={2}>
          The Decentraland wearable will be marked on Polygon Network and sent
          to your address within 72 hours.
        </Typography>
      )}
      {productionStatus === PRODUCTION_STATUSES.DELIVERY && (
        <>
          <Typography mb={2}>
            This item has been already redeemed to the metawerse wearable form.
          </Typography>
          {dclContractAddress && dclTokenId && (
            <CustomButton
              href={`${EXTERNAL_ROUTES.DECENTRALAND_CONTRACTS}${dclContractAddress}/items/${dclTokenId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Check details
            </CustomButton>
          )}
        </>
      )}
    </Card>
  );
};

export default DecentralandRedeemedInfo;
